import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FcPhoneAndroid, FcInfo, FcIdea } from "react-icons/fc";
import { GrMail } from "react-icons/gr";
import { MdDoNotDisturbAlt } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Baseurl } from "../../../config/BaseUrl";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { authActions } from "../../../redux/athentication/Athentication";
import { propertyUpdate } from "../../../redux/property/PropertySlice";
import { toast } from "react-toastify";
import DashboardPropertyCard from "./DashboardPropertyCard";
import "./DashboardListingsNew.css";

const Expired = () => {
  const { loginData } = useSelector((store) => store.Athentication);

  const dispatch = useDispatch();

  const [showProperty, setshowProperty] = useState([]);
  const [propertyloading, setPropertyloading] = useState(true);

  useEffect(() => {
    const userId = loginData._id;
    try {
      const fetchdata = async () => {
        const url = `${Baseurl}/api/v1/property/expired/${userId}`;
        const fetchProperty = await axios(url);
        if (fetchProperty.data.success === true) {
          let reportedProperty = fetchProperty.data.property;
          setshowProperty(reportedProperty);
        }
      };
      fetchdata();
    } catch (error) {}
  }, []);

  const recallClick = async (e, propertyId) => {
    const formdata = {
      mobile: loginData.mobile,
      creadittospent: 5,
    };
    const url = `${Baseurl}/api/v1/user/shopUserByMobile`;

    let fetchData = await axios.put(url, formdata);

    try {
      const authenticForm = {
        ...fetchData.data.user,
        isAuth: true,
      };
      dispatch(authActions.signIn(authenticForm));
    } catch (error) {}
    if (fetchData.data.success) {
      const propertyformdata = {
        propertyId: propertyId,
        propertyStatus: "Underscreening",
      };
      dispatch(propertyUpdate(propertyformdata));
      toast.success("Property Recall Successfully", {
        position: "top-center",
        autoClose: 1500,
      });
    } else {
      toast.error("Please Recharge on Wallet", {
        position: "top-center",
        autoClose: 1000,
      });
    }
  };
  return (
    <div className="mgh-dl-container">
      {/* ================= Header Status Bar ================= */}
      <div className="mgh-dl-info-bar">
        <h4 className="mgh-dl-count-heading">
          <span>Expired Listings</span>
          <span className="mgh-dl-count-pill">
            {showProperty.length}{" "}
            {showProperty.length === 1 ? "Property" : "Properties"}
          </span>
        </h4>

        <div className="mgh-dl-filters-row">
          <span className="mgh-dl-filter-tag">
            <span>Showing: Expired</span>
          </span>
        </div>
      </div>

      {showProperty.length > 0 ? (
        showProperty.map((property, index) => (
          <DashboardPropertyCard
            key={property._id || index}
            property={property}
            packageType={loginData?.packageType || "EXPIRED LISTING"}
            onRecall={(prop) => recallClick(null, prop._id)}
          />
        ))
      ) : (
        <div className="mgh-dl-empty-state">
          <div className="mgh-dl-empty-icon">⌛</div>
          <h3 className="mgh-dl-empty-title">No Expired Properties</h3>
          <p className="mgh-dl-empty-desc">
            You don't have any expired property listings currently.
          </p>
        </div>
      )}
    </div>
  );
};

export default Expired;
